<template>
  <div class="modal-content">
    <div class="modal-body">
      <delivery-notification-details :value="selectedNotification" :all-tags="allTags" :settings="settings" v-on:save="save" v-on:close="hideModal" v-on:remove="remove" />
    </div>
  </div>
</template>

<script>

import { DeliveryNotificationDetails } from '#components'

export default {
  props: ['selectedNotification', 'allTags', 'settings'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (notification) {
      this.$emit('save', notification)
    },
    remove (notification) {
      this.$emit('remove', notification)
    }
  },
  components: {
    DeliveryNotificationDetails
  }
}

</script>